import { useEffect, useMemo, useState } from "react";
import {
  DateRange,
  DateRangeQuickSelect,
  DateRangeSelect,
} from "../../../../components/ui/daterangeselect/DateRangeSelect";
import { DashboardFilterType } from "../../../../constants/dashboardFilters";
import {
  addDaysToToday,
  formatDateForInput,
  getCurrentDate,
} from "../../../../lib/utils";

interface HeaderProps {
  onDateRangeChange?: (range: DateRange) => void;
  onSelectedDaysChange?: (days: DashboardFilterType) => void;
  // onRefresh?: () => void;
}

const Header: React.FC<HeaderProps> = ({
  onDateRangeChange,
  onSelectedDaysChange,
  // onRefresh,
}) => {
  const todayStr = formatDateForInput(getCurrentDate());

  const defaultRange: DateRange = {
    from: formatDateForInput(addDaysToToday(-30)),
    to: todayStr,
  };

  const [selectedRange, setSelectedRange] = useState<DateRange>(defaultRange);

  const selectedDays = useMemo<DashboardFilterType>(() => {
    const parseLocal = (s: string): Date | null => {
      if (!s) return null;
      const [y, m, d] = s.split("-").map(Number);
      if (!y || !m || !d) return null;
      return new Date(y, m - 1, d);
    };

    const from = parseLocal(selectedRange.from);
    const to = parseLocal(selectedRange.to);
    if (!from || !to) return "30";

    const diffMs = to.getTime() - from.getTime();
    const diffDays = Math.floor(diffMs / (24 * 60 * 60 * 1000)) + 1;
    if (diffDays <= 30) return "30";
    if (diffDays <= 60) return "60";
    return "90";
  }, [selectedRange.from, selectedRange.to]);

  useEffect(() => {
    onDateRangeChange?.(selectedRange);
    onSelectedDaysChange?.(selectedDays);
  }, [onDateRangeChange, onSelectedDaysChange, selectedDays, selectedRange]);

  const quickSelectOptions: DateRangeQuickSelect[] = useMemo(
    () => [
      {
        name: "Last 30 days",
        dateRange: {
          from: formatDateForInput(addDaysToToday(-30)),
          to: todayStr,
        },
      },
      {
        name: "Last 60 days",
        dateRange: {
          from: formatDateForInput(addDaysToToday(-60)),
          to: todayStr,
        },
      },
      {
        name: "Last 90 days",
        dateRange: {
          from: formatDateForInput(addDaysToToday(-90)),
          to: todayStr,
        },
      },
      {
        name: "Last 120 days",
        dateRange: {
          from: formatDateForInput(addDaysToToday(-120)),
          to: todayStr,
        },
      },
    ],
    [todayStr],
  );

  // const renderRefreshButton = () => (
  //   <button
  //     type="button"
  //     onClick={onRefresh}
  //     className="px-4 py-2 bg-white border border-gray-300 gap-3 rounded-md flex items-center text-sm font-medium text-gray-700 hover:bg-gray-50"
  //   >
  //     Refresh
  //     <RefreshCcw className="h-4 w-4 mr-2" />
  //   </button>
  // );

  const renderDateRangeSelect = () => (
    <DateRangeSelect
      selectedRange={selectedRange}
      defaultSelection={defaultRange}
      quickSelectOptions={quickSelectOptions}
      maxDate={todayStr}
      onChange={setSelectedRange}
      dropdownClassName="right-0 left-auto"
    />
  );

  return (
    <div className="flex justify-between items-center">
      <div>
        <h2 className="text-lg font-bold text-gray-800">
          Analytics & Insights
        </h2>
        <p className="text-gray-500 text-xs">
          Overview of fraud cases and investigations
        </p>
      </div>
      <div className="flex space-x-4 items-center">
        {renderDateRangeSelect()}
        {/* {renderRefreshButton()} */}
      </div>
    </div>
  );
};

export default Header;
